"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _AmbientLightApi_light, _AmbientLightApi_viewportApi;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmbientLightApi = void 0;
const AbstractLightApi_1 = require("../AbstractLightApi");
class AmbientLightApi extends AbstractLightApi_1.AbstractLightApi {
    // #endregion Properties (2)
    // #region Constructors (1)
    constructor(viewportApi, light) {
        super(viewportApi, light);
        // #region Properties (2)
        _AmbientLightApi_light.set(this, void 0);
        _AmbientLightApi_viewportApi.set(this, void 0);
        __classPrivateFieldSet(this, _AmbientLightApi_viewportApi, viewportApi, "f");
        __classPrivateFieldSet(this, _AmbientLightApi_light, light, "f");
        this.scope = "AmbientLightApi";
    }
}
exports.AmbientLightApi = AmbientLightApi;
_AmbientLightApi_light = new WeakMap(), _AmbientLightApi_viewportApi = new WeakMap();
//# sourceMappingURL=AmbientLightApi.js.map